import {
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text,
    Textarea,
} from "@chakra-ui/react";
import React, {useState} from "react";

// Confirms unlocking a user whose account is locked by too many failed logins.
// The parent's `handleResetAttempts(userId, remarks)` performs the API call and
// owns the success/error toasts.
function ResetAttemptsModal({isOpen, onClose, user, handleResetAttempts}) {
    const [remarks, setRemarks] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const attempts = user?.passwordAttempt;

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await handleResetAttempts(user?.id, remarks.trim());
            setRemarks("");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (isSubmitting) return;
        setRemarks("");
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Reset Login Attempts</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Stack spacing={4}>
                        <Text fontSize="sm" color="gray.500">
                            This clears the failed-login counter for{" "}
                            <Text as="span" fontWeight="600">
                                {user?.fullName || "this user"}
                            </Text>
                            {typeof attempts === "number" ? ` (currently ${attempts} failed attempt${attempts === 1 ? "" : "s"})` : ""}
                            , letting them sign in again.
                        </Text>
                        <FormControl>
                            <FormLabel>Remarks (optional)</FormLabel>
                            <Textarea
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Reason for resetting the login attempts"
                            />
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={handleClose} isDisabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button colorScheme="blue" ml={3} onClick={handleSubmit} isLoading={isSubmitting}>
                        Reset Attempts
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default ResetAttemptsModal;
